import { FC } from 'react';
import { Button } from '@/components/ui';
import BaseInput from '@/components/ui/BaseInput';
import { useTeamWaitlistFormData } from '@/hooks';

interface TeamsWaitlistFormProps {
  onSuccess?: () => void;
}

const TeamsWaitlistForm: FC<TeamsWaitlistFormProps> = ({ onSuccess }) => {
  const { handleChange, handleSubmit, t, formData, formErrors, isSubmitting, submitStatus } = useTeamWaitlistFormData(onSuccess!);

  return (
    <div className="max-w-2xl mx-auto w-full">
      <form onSubmit={handleSubmit} className="space-y-5">
        <BaseInput
          type='text'
          label={t('firstName')}
          name={'firstName'}
          value={formData.firstName}
          onChange={(v) => handleChange('firstName', v)}
          placeholder={t('firstName')}
          error={formErrors.firstName}
        />
        <BaseInput
          type='text'
          label={t('lastName')}
          name={'lastName'}
          value={formData.lastName}
          onChange={(v) => handleChange('lastName', v)}
          placeholder={t('lastName')}
          error={formErrors.lastName}
        />
        <BaseInput
          type='email'
          label={t('email')}
          name='email'
          value={formData.email}
          onChange={(v) => handleChange('email', v)}
          placeholder={t('email')}
          error={formErrors.email}
        />
        <BaseInput
          type='text'
          label={t("company")}
          name="company"
          value={formData.company}
          onChange={(v) => handleChange('company', v)}
          placeholder={t("company")}
          error={formErrors.company}
        />

        <div className="space-y-1">
          <label className="sr-only" htmlFor="teamSize">{t("teamSize")}</label>
          <select
            id="teamSize"
            name="teamSize"
            value={formData.teamSize}
            onChange={(e) => handleChange('teamSize', e.target.value)}
            className="w-full px-4 py-3 rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-gray-900 dark:text-slate-100 transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-brand-electric-blue"
          >
            <option value="">{t("teamSize")}</option>
            <option value="1-5">1–5</option>
            <option value="6-25">6–25</option>
            <option value="26-100">26–100</option>
            <option value="100+">100+</option>
          </select>
        </div>
        <Button
          type='submit'
          disabled={isSubmitting}
        >
          {isSubmitting ? t('waitlist.submitting') : t('waitlist.join')}
        </Button>

        {submitStatus.message && (
          <div className={`p-4 border rounded-lg mt-4 transition-colors duration-200 ${submitStatus.type === 'success' ? 'bg-green-50 dark:bg-green-900/30 border-green-200 dark:border-green-700 text-green-800 dark:text-green-300' : 'bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-700 text-red-800 dark:text-red-300'}`}>
            {submitStatus.message}
          </div>
        )}

        <p className="mt-4 text-xs text-gray-500 dark:text-slate-400 text-center transition-colors duration-200">
          {t('waitlist.microcopy')}
        </p>
      </form>
    </div>
  );
};

export default TeamsWaitlistForm;
